import React from 'react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import ContactSection from '../components/landing/ContactSection';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-20">
        <ContactSection />
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
